class cartPageJs {
    constructor() {
      this.init();
    }
  
    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew'
        });
      }
    }

    shippingCalculator(shippingCalculator) {
      var shippingCalculatorForm = document.querySelector('#shippingCalculatorForm');
      let updatedMap = document.getElementById('google-map')
      
      if (shippingCalculatorForm != null) {
        shippingCalculatorForm.addEventListener('submit', (e) => {
          e.preventDefault();
          var country = document.querySelector('[name="country"]').value;
          var province = document.querySelector('[name="province"]').value;
          var zip = document.querySelector('[name="zip"]').value;
          console.log(zip);
  //         updatedMap.innerHTML = `
  //     <div class="mapouter">
  //             <div class="gmap_canvas">
  //               <iframe
  //                 class="gmap_iframe"
  //                 width="100%"
  //                 frameborder="0"
  //                 scrolling="no"
  //                 marginheight="0"
  //                 marginwidth="0"
  //                 src="https://maps.google.com/maps?width=580&amp;height=416&amp;hl=en&amp;q=${zip} &amp;t=&amp;z=10&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
  //               ></iframe
  //               ><a href="https://mcpenation.com/">https://mcpenation.com</a>
  //             </div>
  //             <style>
  //               .mapouter {
  //                 position: relative;
  //                 text-align: right;
  //                 width: 100%;
  //                 height: 250px;
  //               }
  //               .gmap_canvas {
  //                 overflow: hidden;
  //                 background: none !important;
  //                 width: 100%;
  //                 height: 250px;
  //               }
  //               .gmap_iframe {
  //                 height: 250px !important;
  //               }
  //             </style>
  //       </div>
  // `
          document.querySelector('[data-checkshoppingestimation]').classList.add('loading');
          document.querySelector('[data-checkshoppingestimation]').setAttribute('disabled','true');
    
          fetch(window.routes.cart_fetch_url + '/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            
            response.json().then(function (result) {
              if(document.querySelector('.shipping-calculatore-wrapper .pcErrorMessage')){
                document.querySelector('.shipping-calculatore-wrapper .pcErrorMessage').remove();
              }

              if (result.zip != undefined) {
                document.querySelector('#shippingCalculatorForm').insertAdjacentHTML('beforebegin', `<div class="pcErrorMessage text-danger pt-3">${result.zip[0]}</div>`);
                document.querySelector('[data-checkshoppingestimation]').classList.remove('loading');
                document.querySelector('[data-checkshoppingestimation]').removeAttribute('disabled');
              }
              if(result.shipping_rates && result.shipping_rates.length == 0){
                document.querySelector('#shippingCalculatorForm').insertAdjacentHTML('beforebegin', `<div class="pcErrorMessage text-success pt-3">No Shipping Charges.</div>`);
                document.querySelector('[data-checkshoppingestimation]').classList.remove('loading');
                document.querySelector('[data-checkshoppingestimation]').removeAttribute('disabled');
              }
              if (result.shipping_rates != undefined && result.shipping_rates.length > 0) { 
                let html = `<ul class="list-unstyled m-0 mt-3 pt-1 shipping-rate" style="line-height: 1.285714285714286;">`;
                result.shipping_rates.map((item) => {
                  html += `<li class="form-check mb-2 pb-2 pt-1 w-100">
                        <input type="radio" value="manual" class="form-check-input" style="margin-top: 2px;"name="shipping_rate" data-name="${item.name}" data-price="${item.price}" value="${item.code}" id="shipping_rate_${item.code}" /> 
                        <label for="shipping_rate_${item.code}" class="option_txt form-check-label d-flex justify-content-between fw-light font-size-md" title="Featured">
                        ${item.name} <span class="fw-medium ms-2">${Shopify.formatMoney((parseFloat(item.price) * 100), window.globalVariables.money_format).replaceAll(' USD', '')}</span></label>
                    </li>`;
                })
                html += `<li class="text-center pt-1 mb-n1 "><a class="fw-semibold font-size-sm d-inline-flex align-items-center text-uppercase text-primary ls-1 mt-md-0 mt-2" style="line-height:1.230769230769231;" type="button" name="SubmitShip" data-change-postCode>Change Postal Code</a></li></ul>`;
                document.querySelector('.shipping-calculatore-wrapper').insertAdjacentHTML('beforeend', html);
                document.querySelector('.shipping-calculatore-wrapper #shippingCalculatorForm').classList.add('d-none');
                document.querySelector('[data-change-postCode]').addEventListener('click', (e) => {
                  e.preventDefault();
                  document.querySelector('#shippingCalculatorForm').classList.remove('d-none');
                  document.querySelector('.shipping-calculatore-wrapper .shipping-rate').remove();
                  document.querySelectorAll('[data-ship-total]').forEach((ship) => {
                    ship.innerHTML = '';
                  });
                  document.querySelectorAll('[data-estimated]').forEach((estimated)=>{
                    estimated.innerHTML = '';
                    estimated.classList.remove('my-3');
                  });
                  document.querySelectorAll('[data-subtotal]').forEach((subtotal)=>{
                    subtotal.classList.add('fw-medium');
                  });  
                    document.querySelector('[data-checkshoppingestimation]').classList.remove('loading');
                    document.querySelector('[data-checkshoppingestimation]').removeAttribute('disabled');
                })
  
                document.querySelectorAll('[name="shipping_rate"]').forEach((item) => {
                  item.addEventListener('change', (e) => {
                    var cartPrice = document.querySelector('[data-cartPrice]').getAttribute('data-cartPrice');
                    var price = e.target.getAttribute('data-price');
                    var shippingHtml = `<div class="col">Shipping:</div><div class="col-6 text-end">${Shopify.formatMoney((parseFloat(price) * 100), window.globalVariables.money_format)}</div>`;
                    var estimateHtml = `<div class="col">Estimated Total:</div><div class="col-6 text-end">${Shopify.formatMoney(parseInt(cartPrice) + (parseFloat(price) * 100), window.globalVariables.money_format).replaceAll(' USD', '').replaceAll(' USD', '')}</div>`;
                    document.querySelectorAll('[data-ship-total]').forEach((ship) => {
                      ship.innerHTML = shippingHtml;
                    });
                    document.querySelectorAll('[data-estimated]').forEach((estimated)=>{
                      estimated.innerHTML = estimateHtml;
                      estimated.classList.add('my-3');
                    });
                    document.querySelectorAll('[data-subtotal]').forEach((subtotal)=>{
                      subtotal.classList.remove('fw-medium');
                    });
                  })
                })
              }
            });
          }).catch(function (error) {
            // console.log(error);
          });
  
        })
      }
    }
  
    init() { 
      this._setupCountries();
  
      var shippingCalculator = document.querySelector('[data-checkShoppingEstimation]');
      if (shippingCalculator != null) {
        this.shippingCalculator(shippingCalculator);
      }
  
      var dataGiftmsg = document.querySelector('[data-giftmsg]');
      if (dataGiftmsg != null) {
        this.setGiftmsg(dataGiftmsg);
      }
    }
  }
  
  new cartPageJs;